import React from 'react';

const NotFound = () => <div>This route doesnt exist</div>;

export default NotFound;
